import React from 'react';

import Checkboxes from '@atoms/Checkboxes';
import { DividerLightGreyStyled, H4, H5, LinkMedium } from '@styled';
import AccountPrefFormSection from './AccountPrefFormSection';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';

const AccountPrefsPage = () => {

    return (
        <ErrorHandler>
            <TrackPageView>
                <AccountPrefFormSection
                    pageTitleSub="Account Preferences"
                    nextNavLink="/my-icsc/account/edit-profile"
                    nextNavLabel="Edit Profile"
                >
                    <H5 className="mt-2 mb-3">ICSC Email Preferences</H5>
                    <p className="display8">
                        To receive event and industry updates and newsletters, update your preferences.
                    </p>
                    <LinkMedium
                        className="mb-3"
                        href="https://digital.icsc.com/Manage-Subscription-Preferences.html"
                        target="_blank"
                    >
                        Go to the Email Preference Center
                    </LinkMedium>
                    <p className="display8 mb-3">
                        Please add our email, <a href="mailto:email@icsc.com">email@icsc.com</a>, to your Safe Senders
                        list.
                    </p>

                    <DividerLightGreyStyled className="mt-4" />

                    <H4 className="mb-3">Profile Display Settings</H4>
                    <p className="display8 mb-3">
                        Manage how your profile displays to others in the Networking Platform.
                    </p>
                    <H5 className="mt-3 mb-1">Website Preferences</H5>
                    <Checkboxes
                        name="preferences"
                        options={[
                            {
                                label: 'Display my photo in the member directory',
                                name: 'displayPhoto',
                            },
                            {
                                label: 'Display my email address on ICSC website and publications',
                                name: 'displayEmail',
                            },
                            {
                                label: 'Opt out of meeting invitations',
                                name: 'meetingInviteOptOut',
                            },
                        ]}
                    />
                </AccountPrefFormSection>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default AccountPrefsPage;
